import React from "react";
import { Translate } from "react-redux-i18n";
import Accordion from "../components/Accordion";
import Footer from "../components/Footer";
import { connect } from "react-redux";
import logo from "../assets/logo_celeste.png";
import "./styles/FaqMe.css";

const FAQ_ES = [
  {
    title: "¿Qué es Godiway?",
    content:
      "Godiway es una plataforma de E-commerce que busca ir más allá de los ecommerce comunes, dando un plus más colaborativo en tus transacciones.",
  },
  {
    title: "¿Puedo registrarme?",
    content:
      'Toda persona que tenga criterio formado y desee emprender anunciando con <b>Godiway</b> puede registrarse, o cualquier persona que esté pensando en adquirir bienes o servicios. Más información en <a href="/home/terms_condition">Términos y Condiciones de Uso</a>.',
  },
  {
    title: "¿Cómo registrarme?",
    content:
      'En la parte superior izquierda, <b>Únete a Godiway</b> te llevará a la página de registro donde te pedirá tu email, contraseña y el país. Luego deberás leer y aceptar los términos y condiciones de uso y las políticas de privacidad.',
  },
  {
    title: "¿Es gratis anunciar?",
    content:
      'Es gratis anunciar hasta 15 bienes o servicios diferentes; a partir del 16 deberás adquirir un plan de anuncios. Consulta <a href="/pricing">Suscripciones</a>.',
  },
  {
    title: "¿Qué idioma soporta?",
    content:
      "Actualmente la plataforma soporta 3 idiomas: Inglés, Español y Hebreo.",
  },
  {
    title: "¿Si requiero mayor información de los servicios de Godiway?",
    content:
      'Puedes comunicarte con nosotros en <a href="/contact_me">Contactos</a>, al correo team@godiway.com o al número 1 (786) 477-7340.',
  },
  {
    title: "¿Cómo puedo publicar un anuncio?",
    content:
      "En la parte superior derecha se encuentra el botón de 'Publicar Anuncio'. Haz clic, selecciona el tipo de anuncio, completa los datos del producto o servicio y, en la última pantalla, sube hasta 5 imágenes.",
  },
  {
    title: "¿Hay aplicaciones móviles?",
    content:
      "Tenemos disponibles en Play Store para Android y en App Store para iPhone la app Godiway. Puedes buscarla, descargarla e instalarla.",
  },
];

const FAQ_EN = [
  {
    title: "What is Godiway?",
    content:
      "Godiway is an E-commerce platform that seeks to go beyond common e-commerce by adding a more collaborative approach to your transactions.",
  },
  {
    title: "Can I register?",
    content:
      'Anyone who wants to advertise with <b>Godiway</b> or acquire goods and services can register. More information in <a href="/home/terms_condition">Terms and Conditions of Use</a>.',
  },
  {
    title: "How to register?",
    content:
      'At the top left, <b>Join Godiway</b> takes you to the registration page where you enter your email, password and country. Then you must read and accept the terms of use and privacy policies.',
  },
  {
    title: "Is it free to advertise?",
    content:
      'It is free to advertise up to 15 different goods or services. After that you must purchase an ad plan. See <a href="/pricing">Subscriptions</a>.',
  },
  {
    title: "What languages does it support?",
    content: "Currently the platform supports 3 languages: English, Spanish and Hebrew.",
  },
  {
    title: "If I need more information, where can I get help?",
    content:
      'You can reach us on <a href="/contact_me">Contacts</a>, at team@godiway.com or by phone at 1 (786) 477-7340.',
  },
  {
    title: "How can I post an ad?",
    content:
      "At the top right there is a 'Publish Ad' button. Click it, select the ad type, fill in the product or service details and upload up to 5 images on the last screen.",
  },
  {
    title: "Are there mobile apps?",
    content:
      "The Godiway app is available on the Play Store for Android and the App Store for iPhone. You can search, download and install it.",
  },
];

class FaqMe extends React.Component {
  getFaqItems = () => {
    if (this.props.lang === "es") {
      return FAQ_ES;
    }
    return FAQ_EN;
  };

  render() {
    const items = this.getFaqItems();

    return (
      <React.Fragment>
        <div className="faq-page">
          <div className="faq-card">
            <header className="faq-card__header">
              <img src={logo} alt="Godiway" className="faq-card__logo" />
              <h1 className="faq-card__title">
                <Translate value="faq_title" />
              </h1>
              <p className="faq-card__subtitle">
                <Translate value="faq_me_subtitle" />
              </p>
            </header>

            <div className="faq-card__body">
              {items.map((item) => (
                <Accordion
                  key={item.title}
                  title={item.title}
                  content={item.content}
                />
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    lang: reducer.i18n.locale,
  };
}

export default connect(mapStateToProps, null)(FaqMe);
